<template>
  <div>
    <v-dialog width="650" v-model="dialog">
      <v-card>
        <v-card-title>
          <div class="d-flex justify-space-between" :style="{ width: '100%' }">
            <div>
              QUÉT MÃ VÀ ĐIỀU CHỈNH DANH SÁCH THEO THỰC TẾ
            </div>
            <div class="cursor-pointer icon-close" @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </div>
          </div>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <div class="content">
            <v-text-field
              outlined
              v-if="!loading"
              ref="inputField"
              label="Mã IMEI"
              v-model="imeikey"
              readonly
              hide-details
              id="imei-input"
              :style="{ display: 'none' }"
            />
            <v-text-field
              label="Mã hoá đơn"
              placeholder="Mã hoá đơn"
              id="notes"
              v-model="payload.billCode"
              outlined
              dense
              hide-details
              class="pt-4"
            >
            </v-text-field>
            <v-text-field
              label="Mã phiếu / DO"
              placeholder="Mã phiếu / DO"
              id="notes"
              v-model="payload.doCode"
              outlined
              dense
              hide-details
              class="pt-4"
            >
            </v-text-field>
            <v-text-field
              label="Mã đơn / PO"
              placeholder="Mã đơn / PO"
              id="notes"
              v-model="payload.poCode"
              outlined
              dense
              hide-details
              class="pt-4"
            >
            </v-text-field>
            <v-divider class="mt-4" />
            <div class="information mt-4">
              <div>{{ `Tổng số lượng hàng: ${total}` }}</div>
              <div>{{ `Số lượng có sẵn: ${existed + listScanImei.length}` }}</div>
              <div>{{ `Số lượng còn lại: ${total - existed - listScanImei.length}` }}</div>
            </div>
            <div class="d-inline-flex table-imei mt-4">
              <table class="table">
                <thead>
                  <tr>
                    <th :style="{ width: '120px', 'text-align': 'start', 'font-size': '.75rem' }">{{ 'Mã IMEI' }}</th>
                    <th :style="{ width: '400px', 'text-align': 'start', 'font-size': '.75rem' }">{{ 'Ghi chú' }}</th>
                    <th :style="{ width: '80px', 'font-size': '.75rem' }">{{ 'Thao tác' }}</th>
                  </tr>
                </thead>
                <tbody class="table-content" v-if="listScanImei.length">
                  <tr
                    v-for="(item, index) in listScanImei"
                    :key="index"
                    class="pa-1"
                    :style="{ 'border-bottom': '1px solid #ddd' }"
                  >
                    <td>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div v-on="on" v-bind="attrs" class="text-ellipsis" :style="{ width: '104px' }">
                            {{ item.imei }}
                          </div>
                        </template>
                        <span class="white--text text-justify" :style="{ 'font-size': '.875rem' }">
                          {{ item.imei }}
                        </span>
                      </v-tooltip>
                    </td>
                    <td>
                      <v-text-field
                        placeholder="Ghi chú"
                        @input="text => item.notes"
                        id="notes"
                        v-model="item.notes"
                        outlined
                        hide-details
                        dense
                        :style="{ 'font-size': '.875rem', 'background-color': 'white' }"
                      >
                      </v-text-field>
                    </td>
                    <td>
                      <div class="d-flex justify-center">
                        <v-icon @click="onDelete(item)">mdi-minus-box-outline</v-icon>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="3">
                      <div class="d-flex justify-center">
                        {{ 'Không có dữ liệu' }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <div class="d-flex justify-end" :style="{ width: '100%' }">
            <v-btn color="primary" class="ma-2 white--text" @click="onSave">
              <v-icon size="18" dark class="pr-1">
                mdi-check
              </v-icon>
              Xác nhận nhập
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { debounce, get } from 'lodash'
import { mapActions, mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      selectAuditProductDetail(state) {
        return state['auditProducts'].item
      }
    })
  },
  data() {
    return {
      loading: true,
      dialog: false,
      listImei: [],
      imeikey: '',
      listScanImei: [],
      scanStatus: 0,
      isChecking: false,
      payload: {
        billCode: '',
        poCode: '',
        doCode: ''
      },
      headers: [
        { text: 'Mã IMEI', value: 'imei', width: '120px' },
        { text: 'Ghi chú', value: 'notes', width: '416px' },
        { text: 'Thao tác', value: 'actions', align: 'center', width: '64px' }
      ],
      total: 0,
      existed: 0,
      get
    }
  },
  methods: {
    ...mapActions({
      count: 'auditProducts/countItemsIndependent'
    }),
    async openDialog() {
      this.refresh()
      this.dialog = true
      this.loading = true
      this.existed = await this.count({ importCheck: this.$route.params.id })
      this.total = get(this.selectAuditProductDetail, 'requestQuantity', 0)
      window.addEventListener('keydown', this.onKeyDown)
      setTimeout(() => {
        this.loading = false
      }, 1000)
    },
    onKeyDown(event) {
      const id = get(event, 'target.id')
      if (id !== 'notes') {
        this.scanStatus = 1
        if (this.dialog && event.key !== undefined && event.key.length === 1) {
          this.imeikey += event.key
          event.preventDefault()
        }
      }
    },
    refresh() {
      this.listImei = []
      this.listScanImei = []
    },
    closeDialog() {
      window.removeEventListener('keydown', this.onKeyDown)
      this.dialog = false
    },
    onSave() {
      const params = {
        billCode: this.payload.billCode,
        doCode: this.payload.doCode,
        poCode: this.payload.poCode,
        listImei: this.listScanImei
      }
      this.$emit('onSave', params)
    },
    onDelete(item) {
      const index = this.listScanImei.findIndex(v => v.imei === item.imei)
      if (index > -1) this.listScanImei.splice(index, 1)
    },
    onCheckImei(imeiCode) {
      if (this.total - this.existed - this.listScanImei.length <= 0) return this.$alert.error('Đã quét đủ số hàng')
      else if (imeiCode.length) {
        const validate = this.listScanImei.filter(v => v.imei === imeiCode)
        if (validate.length) return this.$alert.error('Mã đã tồn tại trong bảng')
        this.listScanImei.push({ imei: imeiCode, notes: '' })
      }
    },
    debounce: debounce(async function() {
      try {
        this.loading = true
        this.onCheckImei(this.imeikey)
        this.imeikey = ''
        this.scanStatus = 0
        setTimeout(() => {
          this.loading = false
        }, 200)
      } catch (error) {
        this.loading = false
      }
    }, 1000)
  },
  watch: {
    scanStatus: {
      handler(val) {
        if (val === 1) {
          this.debounce()
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import './src/assets/auditTrail/scan-imei.scss';
</style>
